module.exports = __webpack_public_path__ + "img/blackluck.2a45c300.svg";